<template>
  <button
    class="border border-grey-3 rounded-sm w-full py-2 px-2 flex items-center justify-start text-grey-1 text-lg"
  >
    <component
      :is="props.icon"
      class="w-[18px] h-[18px] mr-4"
    />
    <slot />
  </button>
</template>

<script setup>
const props = defineProps({
  icon: {
    required: true
  }
})

const emit = defineEmits([])
</script>
